/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Grid } from "@mui/material";
import AuthWrapper from "Welcome/auth/AuthWrapper";
import WelcomeMessaging from "Welcome/welcome-messaging";
import WelcomeHeaderBar from "Welcome/welcome-bar";
import AuthFooter from "Welcome/auth/AuthFooter";

const Welcome = () => (
    <>
        <div
            style={{
                backgroundColor: "#F4f4f4",
                border: "1px solid transparent",
                margin: "0 0 0 0",
            }}
        >
            <WelcomeHeaderBar />
            <AuthWrapper>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <WelcomeMessaging />
                    </Grid>
                </Grid>
            </AuthWrapper>
            <AuthFooter />
        </div>
    </>
);

export { Welcome };
